import React, { useEffect } from 'react';
import { AppRouter } from './src/router/index';
import { useAuthStore } from './src/store/authStore';
import { useConnectionStore } from './src/store/connectionStore';
import { updatesWS } from './src/services/websocket';
import { ToastProvider } from './src/components/ToastProvider';
import { ThemeProvider } from './src/theme/index';
import { LocationEnforcer } from './src/components/LocationEnforcer';

const App: React.FC = () => {
  const { initialize, isAuthenticated, logout, refreshProfile } = useAuthStore();

  useEffect(() => {
    initialize();
  }, []);

  useEffect(() => {
    const handler = () => {
      logout().catch(() => {});
    };
    window.addEventListener('survey-connect:account-suspended', handler);
    return () => window.removeEventListener('survey-connect:account-suspended', handler);
  }, [logout]);

  useEffect(() => {
    if (!isAuthenticated) return;
    updatesWS.connect().catch(() => {});
    const offNotification = updatesWS.on('notification', (message) => {
      useConnectionStore.getState().incrementNotifications();
      const payload: any = message.payload || {};
      const text = `${payload.title || ''} ${payload.message || ''}`.toLowerCase();
      if (text.includes('suspended')) {
        logout().catch(() => {});
      } else {
        refreshProfile().catch(() => {});
      }
    });
    const focusHandler = () => {
      refreshProfile().catch(() => {});
    };
    window.addEventListener('focus', focusHandler);
    return () => {
      offNotification();
      window.removeEventListener('focus', focusHandler);
      updatesWS.disconnect();
    };
  }, [isAuthenticated, logout, refreshProfile]);

  return (
    <ThemeProvider>
      <ToastProvider>
        <LocationEnforcer>
          <AppRouter />
        </LocationEnforcer>
      </ToastProvider>
    </ThemeProvider>
  );
};

export default App;
